module.exports = __webpack_public_path__ + "img/img3.41b7992e.jpg";